import React from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

const LoaderPage = () => {
  return (
    <div className="min-h-screen theme-bg-secondary flex items-center justify-center">
      <LoadingSpinner message="Loading Animation Demo" />
    </div>
  );
};

export default LoaderPage;
